import { faDice, faList, faAt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction } from "react";
import { Tab, Modal, Nav } from "react-bootstrap";
import { IComponentModal } from "../../../../Components/Modais/IModalComponent";
import FormularioModal from "../FormularioModal";
import ConfiguracaoTemplateDoFormulario from "./ConfiguracaoTemplateDoFormulario";
import EditarFormularioDados from "./EditarFormularioDados";

interface IEditarFormularioProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    setModal: Dispatch<SetStateAction<IComponentModal | undefined>>;
    idFormulario: number;
    updateList(): void;
    recemCriado?: boolean;
}

export default function EditarFormulario(props: IEditarFormularioProps) {
    const defaultActiveKey = props.recemCriado ? "perguntas" : "geral";
    return (
        <Tab.Container defaultActiveKey={defaultActiveKey}>
            <Nav
                variant="tabs"
                role="tablist"
                className="nav-tabs nav-bold nav-tabs-line px-8 pt-4"
                defaultActiveKey={defaultActiveKey}
            >
                <Nav.Item>
                    <Nav.Link eventKey="geral">
                        <span className="nav-icon">
                            <FontAwesomeIcon icon={faDice} />
                        </span>
                        <span className="nav-text">Geral</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="perguntas">
                        <span className="nav-icon">
                            <FontAwesomeIcon icon={faList} />
                        </span>
                        <span className="nav-text">Perguntas</span>
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link eventKey="configTemplate">
                        <span className="nav-icon">
                            <FontAwesomeIcon icon={faAt} />
                        </span>
                        <span className="nav-text">
                            Configuração de Template
                        </span>
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            <Modal.Body>
                <Tab.Content>
                    <Tab.Pane eventKey="geral">
                        <EditarFormularioDados
                            updateList={props.updateList}
                            idFormulario={props.idFormulario}
                        />
                    </Tab.Pane>
                    <Tab.Pane eventKey="perguntas">
                        <FormularioModal {...props} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="configTemplate">
                        <ConfiguracaoTemplateDoFormulario
                            idFormulario={props.idFormulario}
                        />
                    </Tab.Pane>
                </Tab.Content>
            </Modal.Body>
        </Tab.Container>
    );
}
